import {
  registerDecorator,
  ValidationArguments,
  ValidationOptions,
  ValidatorConstraint,
  ValidatorConstraintInterface,
} from 'class-validator';

export function ValidateBegin(validationOptions?: ValidationOptions) {
  return (object: any, propertyName: string) => {
    registerDecorator({
      target: object.constructor,
      propertyName,
      options: validationOptions,
      validator: ValidateBeginConstraint,
    });
  };
}

@ValidatorConstraint({ name: 'ValidateBegin' })
export class ValidateBeginConstraint implements ValidatorConstraintInterface {
  validate(value: number, args: ValidationArguments) {
    const obj = args.object as any;

    // Only validate if operator is Between
    if (obj.operator !== 'BETWEEN') {
      return true;
    }

    // Check IsLessThan validation: begin must be less than end
    if (value >= obj.end) {
      return false;
    }

    // Check Min validation: begin must be greater than 0 if requirePositive is true
    if (obj.requirePositive && value <= 0) {
      return false;
    }

    return true;
  }

  defaultMessage(args: ValidationArguments) {
    const obj = args.object as any;
    const value = args.value;

    if (obj.operator === 'BETWEEN') {
      if (value >= obj.end) {
        return 'Please enter the lower value followed by the higher value';
      }
      if (obj.requirePositive && value <= 0) {
        return 'Begin must be greater than 0';
      }
    }

    return 'Invalid value';
  }
}
